import React from 'react';
import { Close, DoneAll, Search } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { nInt, currency, onlyInteger } from 'hooks/Pipe';
import { WithApp } from 'contexts/appContext';
import ResponseData from './ResponseData';

const columns = [
  { field: 'ItemCode', type: 'text', align: 'left', width: 150, header: 'Código' },
  { field: 'ItemName', type: 'text', align: 'left', width: 250, header: 'Producto' },
  { field: 'Aviable', type: 'number', align: 'right', width: 100, header: 'Stock' },
  { field: 'NumInSale', type: 'number', align: 'right', width: 130, header: 'Cant. x Paq.' },
  { field: 'digitate_packages', align: 'left', width: 100, header: 'Paquetes' },
  { field: 'digitate_units', align: 'left', width: 100, header: 'Unidades' },
  { field: 'unit_price', type: 'number', align: 'right', width: 120, header: 'Precio Unit.' },
  { field: 'package_price', type: 'number', align: 'right', width: 120, header: 'Precio Paq.' },
  { field: 'import', type: 'number', align: 'right', width: 100, header: 'Importe' },
  { field: 'actions', type: 'custom', align: 'center', width: 130, header: 'Acciones' },
];

function NewSaleInvoiceDetails(props) {
  const { productSelected, setProductSelected } = props;
  const { products, setProducts, getProduct } = props;
  const { openModalProduct, setOpenModalProduct } = props;
  const {
    process,
    processing,
    classes,
    productSelects,
    dataSale,
    total,
    calculator,
    paymentTerm,
    showNotify,
    deleteRow,
    calcImport,
    handleChangeRow,
    addProductCheck,
  } = props;

  const { responseData, setAlertAprobed, approveOrCancel, continuar, updateOrder } = props;

  if (process === true) {
    return (
      <ResponseData
        responseData={responseData}
        setAlertAprobed={setAlertAprobed}
        approveOrCancel={approveOrCancel}
        continuar={continuar}
        updateOrder={updateOrder}
      />
    );
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell width="50">#</TableCell>
              {columns.map((item, i) => {
                return (
                  <TableCell key={i} width={item.width} align={item.align}>
                    {item.header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={productSelects + dataSale.base_zone_id} className={classes.subHeader}>
              <TableCell>
                <Button
                  color={props.themeContext.buttonColorSuccess}
                  round
                  justIcon
                  simple
                  onClick={() => setOpenModalProduct(true)}
                  disabled={
                    !!dataSale.base_seller_id &&
                    !!dataSale.base_customer_route_id &&
                    process === false
                      ? false
                      : true
                  }
                >
                  <Search style={{ width: '27px', height: '27px' }} />
                </Button>
              </TableCell>
              <TableCell>
                <Autocomplete
                  key={dataSale.base_zone_id + dataSale.base_seller_id}
                  options={products}
                  getOptionLabel={(option) => option.ItemCode}
                  renderInput={(params) => (
                    <TextField {...params} margin="normal" size="small" required />
                  )}
                  onInputChange={(e) => {
                    if (e.target.value?.length > 3) {
                      getProduct(e.target.value);
                    } else {
                      setProductSelected({});
                    }
                  }}
                  noOptionsText="Mínimo 4 caracteres"
                  clearOnEscape={true}
                  clearOnBlur={false}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && products.length === 1) {
                      setProductSelected({
                        ...products[0],
                        digitate_packages: 0,
                        digitate_units: 0,
                      });
                      setProducts([]);
                    }
                  }}
                  onChange={(e, item) => {
                    if (!!item) {
                      setProductSelected({
                        ...item,
                        digitate_packages: 0,
                        digitate_units: 0,
                      });
                    } else {
                      setProductSelected({});
                      setProducts([]);
                    }
                  }}
                  disabled={
                    !!dataSale.base_seller_id && !!dataSale.base_customer_route_id ? false : true
                  }
                />
              </TableCell>
              <TableCell>{productSelected.ItemName || '-'}</TableCell>
              <TableCell align="right">
                {productSelected.TreeType === 'N' ? productSelected.Aviable : '-'}
              </TableCell>
              <TableCell align="right">{nInt(productSelected.NumInSale)}</TableCell>
              <TableCell>
                <TextField
                  key={productSelected.ItemCode + productSelected.digitate_units}
                  name="digitate_packages"
                  value={productSelected.digitate_packages || ''}
                  onChange={(e) => {
                    setProductSelected({
                      ...productSelected,
                      digitate_packages: parseInt(e.target.value),
                    });
                  }}
                  inputProps={{ style: { textAlign: 'right' } }}
                  onKeyPress={onlyInteger}
                  fullWidth
                  margin="normal"
                  size="small"
                  disabled={!!productSelected.ItemCode ? false : true}
                />
              </TableCell>
              <TableCell>
                <TextField
                  key={productSelected.ItemCode + productSelected.digitate_packages}
                  name="digitate_units"
                  value={productSelected.digitate_units || ''}
                  onChange={(e) => {
                    setProductSelected({
                      ...productSelected,
                      digitate_units: parseInt(e.target.value),
                    });
                  }}
                  onBlur={() => calculator(productSelected, 'Header')}
                  inputProps={{ style: { textAlign: 'right' } }}
                  onKeyPress={onlyInteger}
                  fullWidth
                  margin="normal"
                  size="small"
                  disabled={!!productSelected.ItemCode ? false : true}
                />
              </TableCell>
              <TableCell align="right">
                {parseFloat(productSelected.unit_price || 0).toFixed(4)}
              </TableCell>
              <TableCell align="right">
                {parseFloat(productSelected.package_price || 0).toFixed(4)}
              </TableCell>
              <TableCell align="right">
                {productSelected.id ? currency(calcImport(productSelected)) : 0}
              </TableCell>
              <TableCell align="center">
                <Button
                  type="submit"
                  justIcon
                  round
                  size="sm"
                  color={props.themeContext.buttonColorSuccess}
                  onClick={() => {
                    if (!!productSelected.id) {
                      if (productSelects.some((item) => item.id == productSelected.id)) {
                        showNotify('Ya existe este producto', 'info');
                        return;
                      }
                      addProductCheck(productSelected, calcImport(productSelected));
                    } else {
                      showNotify('Elija un producto', 'info');
                    }
                  }}
                  disabled={!!productSelected.ItemCode ? false : true}
                >
                  <DoneAll />
                </Button>
              </TableCell>
            </TableRow>
            {productSelects.map((obj, i) => {
              const interest =
                paymentTerm.interest_rate > 0
                  ? 1 + parseFloat(paymentTerm.interest_rate || 0) / 100
                  : 0;

              const unitPrice =
                paymentTerm.interest_rate > 0 ? obj.unit_price * interest : obj.unit_price;

              let packagePrice =
                paymentTerm.interest_rate > 0 ? obj.package_price * interest : obj.package_price;

              if (dataSale.base_canal_id == 1) {
                packagePrice = unitPrice;
              } else {
                packagePrice = packagePrice;
              }

              return (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{obj.ItemCode}</TableCell>
                  <TableCell>{obj.ItemName}</TableCell>
                  <TableCell align="right">{obj.Aviable}</TableCell>
                  <TableCell align="right">{parseInt(obj.NumInSale)}</TableCell>
                  <TableCell>
                    <TextField
                      key={openModalProduct + productSelects + obj.digitate_units}
                      name="digitate_packages"
                      value={obj.digitate_packages || ''}
                      onChange={(e) => handleChangeRow(e, obj.id)}
                      inputProps={{ style: { textAlign: 'right' } }}
                      onKeyPress={onlyInteger}
                      fullWidth
                      margin="normal"
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      key={openModalProduct + productSelects + obj.digitate_packages}
                      name="digitate_units"
                      value={obj.digitate_units || ''}
                      onChange={(e) => handleChangeRow(e, obj.id)}
                      inputProps={{ style: { textAlign: 'right' } }}
                      onKeyPress={onlyInteger}
                      fullWidth
                      margin="normal"
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="right">{parseFloat(unitPrice || 0).toFixed(4)}</TableCell>
                  <TableCell align="right">{parseFloat(packagePrice || 0).toFixed(4)}</TableCell>
                  <TableCell align="right">{currency(calcImport(obj))}</TableCell>
                  <TableCell align="center">
                    <Button
                      justIcon
                      round
                      simple
                      color={props.themeContext.buttonColorDanger}
                      onClick={() => deleteRow(obj.id)}
                    >
                      <Close />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow className={classes.totals}>
              <TableCell align="right" colSpan="5">
                Total:
              </TableCell>
              <TableCell align="right">{total.digitate_packages || 0}</TableCell>
              <TableCell align="right">{total.digitate_units || 0}</TableCell>
              <TableCell align="right" colSpan="3">
                {currency(total.import)}
              </TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {productSelects.length > 0 ? (
        <Button
          formNoValidate={false}
          type="submit"
          form="formNewSale"
          color={props.themeContext.buttonColorSuccess}
          style={{ marginTop: '15px', float: 'right' }}
          disabled={processing}
        >
          {processing ? 'Procesando...' : 'Procesar'}
        </Button>
      ) : undefined}
    </>
  );
}

export default WithApp(NewSaleInvoiceDetails);
